import {Button, Col, Row} from 'antd';
import React, { Fragment } from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {translate} from 'react-i18next';
import { GUTTER_SM, MARGIN_MD } from '../../../styles/constants';
import FileMappingComponentList from '../../file-mapping-component-list';
import { addAllELComponentMapperComponent, addELComponentMapperComponent, removeAllELComponentMapperComponent, removeELComponentMapperComponent, selectELComponentMapperComponent } from './actions';

const mapStateToProps = state => ({
  components: state.scenes.easyLoading.components,
  selectedColumnName: state.scenes.easyLoading.selectedColumnName,
  selectedCubeComponentCode: state.scenes.easyLoading.selectedCubeComponentCode,
  selectedComponent: state.scenes.easyLoading.selectedComponent,
});

const mapDispatchToProps = dispatch => ({
  onComponentAdd: (columnName, cubeComponentCode) =>
    dispatch(addELComponentMapperComponent(columnName, cubeComponentCode)),
  onComponentAddAll: () =>
    dispatch(addAllELComponentMapperComponent()),
  onComponentRemove: (columnName, cubeComponentCode) =>
    dispatch(removeELComponentMapperComponent(columnName, cubeComponentCode)),
  onComponentRemoveAll: () =>
    dispatch(removeAllELComponentMapperComponent()),
  onComponentSelect: (columnName, cubeComponentCode) =>
    dispatch(selectELComponentMapperComponent(columnName, cubeComponentCode))
});

const ELComponentMapper = ({
                            t,
                            components,
                            selectedMapping,
                            selectedColumnName,
                            selectedCubeComponentCode,
                            selectedComponent,
                            onComponentAdd,
                            onComponentAddAll,
                            onComponentRemove,
                            onComponentRemoveAll,
                            onComponentSelect,
                            }) =>
{
  const handleComponentSelect = (columnName, cubeComponentCode) => {
    if (selectedMapping === -1) {
      onComponentSelect(columnName, cubeComponentCode);
    }
  } 

    return (                            
      <Fragment>
        <Row type="flex" justify="space-between" style={{ marginBottom: MARGIN_MD }}>
          <Col>
            <Row type="flex" gutter={GUTTER_SM}>
              <Col>
                <Button
                  onClick={() => onComponentAdd(selectedColumnName, selectedCubeComponentCode)}
                  disabled={selectedColumnName === null || selectedCubeComponentCode === null  || selectedMapping > -1}
                  title={t('components.easyLoading.steps.mapping.cards.componentMapper.componentAddButton.title')}
                  icon="plus"
                />                
              </Col>
              <Col>
                <Button
                  onClick={() => onComponentAddAll()}
                  disabled={selectedMapping > -1}
                  title={t('components.easyLoading.steps.mapping.cards.componentMapper.componentAddAllButton.title')}
                  style={{
                    'paddingLeft': 6,
                    'paddingRight': 6,
                    'fontSize': 22
                  }}
                >
                  ++
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => onComponentRemove(selectedComponent.columnName, selectedComponent.cubeComponentCode)}
                  disabled={selectedComponent === null || selectedMapping > -1}
                  icon="minus"
                  title={t('components.easyLoading.steps.mapping.cards.componentMapper.componentRemoveButton.title')}
                />
              </Col>
            </Row>
          </Col>
          <Col className="file-mapping__file-mapping__wizardjoined__icons">
            <Button
              disabled={components.length === 0  || selectedMapping > -1}
              onClick={() => onComponentRemoveAll()}
              icon="delete"
              title={t('components.easyLoading.steps.mapping.cards.componentMapper.componentRemoveAllButton.title')}
            />
          </Col>
        </Row>
        <FileMappingComponentList
          value={components}
          selected={
            selectedComponent !== null
              ? `${selectedComponent.columnName}${selectedComponent.cubeComponentCode}`
              : null
          }
          onSelect={({ columnName, cubeComponentCode }) => handleComponentSelect(columnName, cubeComponentCode)}
          columnNameKey="columnName"
          cubeComponentCodeKey="cubeComponentCode"
        />
      </Fragment> 
    )
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(ELComponentMapper);



// WEBPACK FOOTER //
// ./src/components/easy-loading/mapping-step/ELComponentMapper.jsx